<ng-container *transloco="let t;">
    <form [formGroup]="contractForm">
        <div class="contract-control-step-zero">
            <h2 class="step-heading-title">{{t('Heading text (contractControl stepForm) - Contract details')}}</h2>    
            <div class="form-group">
                <label>{{t('Input label text (contractControl stepForm) - Contract name')}}</label>
                <input type="text" formControlName="contract_control_name" class="form-control" [ngClass]="{ 'is-invalid error': (currentFormData$ | async)?.isCurrentFormSubmitted && contractForm.get('contract_control_name').errors}" />
                <div *ngIf="(currentFormData$ | async)?.isCurrentFormSubmitted && contractForm.get('contract_control_name').errors" class="invalid-feedback" [ngClass]="{ 'd-block': (currentFormData$ | async)?.isCurrentFormSubmitted && contractForm.get('contract_control_name').errors }">
                    <div *ngIf="contractForm.get('contract_control_name').errors.required">{{t('Validation text (contractControl stepForm) - Contract name is required')}}</div>
                </div>
            </div>
        
            <div class="form-group">
                <label for="">{{t('Document type label (general) - Document type')}}</label>
                <ng-select 
                    #SelectDocumentType 
                    [items]="documentTypes | documentTypeSelectorFor: 'contract'" 
                    formControlName="document_type_id" 
                    bindLabel="document_type" 
                    bindValue="id" 
                    [readonly]="readonly" 
                    [loading] ="isDocumentTypesLoading$ | async"
                    [loadingText]="t('Loading mask text (general) - Loading')"
                    [searchable]="searchable" 
                    [ngClass]="{ 'is-invalid error': (currentFormData$ | async)?.isCurrentFormSubmitted && contractForm.get('document_type_id').errors}" 
                    (change)="onDocumentTypeChange($event)">
                    <ng-template ng-loadingspinner-tmp>
                        <span class="spinner-border spinner-border-sm me-1"></span>
                    </ng-template>
                    <ng-template ng-header-tmp>
                        <input class="form-control w-100" type="text" />
                        <span (click)="addNewDocumentType()" class="mt-50 add-docTypebtn"><i data-feather="plus" [size]="16" class="cursor-pointer"></i> {{t("Add new document type text - (Contract control listing section - Add contract control modal) - Add new document type text")}}</span>
                    </ng-template>
                </ng-select>
                <div *ngIf="(currentFormData$ | async)?.isCurrentFormSubmitted && contractForm.get('document_type_id').errors" class="invalid-feedback" [ngClass]="{ 'd-block': (currentFormData$ | async)?.isCurrentFormSubmitted && contractForm.get('document_type_id').errors }">
                    <div *ngIf="contractForm.get('document_type_id').errors.required">{{t('Validation text (contractControl stepForm) - Document type is required')}}</div>
                </div>
            </div>
    
            @for(field of categoryFields; track field; let idx = $index){
                <div class="form-group document_category_field">
                     <app-cascader-select 
                        [categories]="[field.category]" 
                        [selectedIds]="getCategoryControlValue(field)" 
                        [label]="field.category.category_name"
                        [customClass]="'contract-control-cascader'"
                        (save)="selectedCategoriesChange($event, field, idx)"
                    ></app-cascader-select>
                </div>
            }
                
            <div class="form-group">
                <label for="">{{t('Counter party label (contractControl stepForm) - Counter party')}}</label>
                <ng-select #Selectorganization [items]="organizations" bindLabel="name" bindValue="id" formControlName="organization_id"
                    [searchable]="searchable"
                    [loading] ="loadingOrganizations"
                    [loadingText]="t('Loading mask text (general) - Loading')"
                >
                    <ng-template ng-loadingspinner-tmp>
                        <span class="spinner-border spinner-border-sm me-1"></span>
                    </ng-template>
                    <ng-template ng-header-tmp>
                        <input class="form-control w-100" type="text" />
                        <span (click)="addLinkNewOrganizationModalClick()" class="mt-50 add-docTypebtn"><i data-feather="plus" [size]="16" class="cursor-pointer"></i> {{t("New Organization Button label (contractControl stepForm) - New Organization")}}</span>
                    </ng-template>
                </ng-select>
            </div>        
        </div>
    </form>
    
    
    <!-- Edit layout Modal -->
    <!-- <ng-template #CC_EditlayoutModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">Edit Layout</h4>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body py-2 px-0" tabindex="0" ngbAutofocus>
            <div class="CC_editLayoutScrollCont">
                <app-contract-control-edit-layout [view]="editLayoutCallableViewEnum.AddDocumentType" [layoutsetting]="{}" [isContractControlDetailView]="true"></app-contract-control-edit-layout> 
            </div>
        </div>
    </ng-template> -->
    <!-- / Edit layout Modal -->
    </ng-container>